import React from 'react';
import { Typography } from '@material-ui/core';

export const LabelValueTypography = ({ name, className, label }: { name: string; className?: string; label?: boolean }) => (
  <Typography className={className} variant={label ? 'h5' : 'body1'}>
    {name}
  </Typography>
);
